import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
import ScriptEmbed from '/tribalism-component/script-embed.js';
import styles from "../../../../services/ServicesSections.module.scss";
// core components





export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">


        <GridItem xs={12} sm={8} md={8}>
        <p> 

        August 9th marks the annual International day of the World's Indigenous People. In this time of Global pandemic, more than ever indigenous peoples of the world need particular consideration, especially given they can be more susceptible to novel illnesses such as Covid-19. 
        </p> 
        <p> 
          Whilst we have not been able to source the break down of case numbers for Indigenous populations compared to non-indigenous, there are clearly higher case loads and deaths in black and brown populations in the United States <a href="https://www.nytimes.com/interactive/2020/07/05/us/coronavirus-latinos-african-americans-cdc-data.html" target="_blank" style={{wordWrap: 'break-word'}}>https://www.nytimes.com/interactive/2020/07/05/us/coronavirus-latinos-african-americans-cdc-data.html</a> 
        </p> 
        </GridItem>
        
        <GridItem xs={12} sm={8} md={8}>
          <blockquote className="twitter-tweet">
            <p lang="en" dir="ltr">
              Today commemorates the 
              <a href="https://twitter.com/hashtag/InternationalDayoftheWorldsIndigenousPeoples?src=hash&amp;ref_src=twsrc%5Etfw">
                #InternationalDayoftheWorldsIndigenousPeoples
              </a> to mark the date of the inaugural session of the Working Group on Indigenous Populations at the UN in 1982. 
              <a href="https://twitter.com/hashtag/IndigenousDay?src=hash&amp;ref_src=twsrc%5Etfw">
                #IndigenousDay
              </a> 
              <a href="https://twitter.com/hashtag/autochtones?src=hash&amp;ref_src=twsrc%5Etfw">
                #autochtones
              </a> 
              <a href="https://twitter.com/hashtag/SomosIndigenas?src=hash&amp;ref_src=twsrc%5Etfw">
                #SomosIndigenas
              </a> 
              <a href="https://twitter.com/hashtag/DiaDosPovosIndigenas?src=hash&amp;ref_src=twsrc%5Etfw">
                #DiaDosPovosIndigenas</a> 
              <a href="https://twitter.com/VancouverPD?ref_src=twsrc%5Etfw">
                @VancouverPD
              </a> 
              <a href="https://twitter.com/VPDDiversity?ref_src=twsrc%5Etfw">
                @VPDDiversity
              </a> 
              <a href="https://t.co/49vq4S8S0J">pic.twitter.com/49vq4S8S0J</a>
            </p>
            &mdash; Fiona Wilson (@FionaWilsonVPD) 
            <a href="https://twitter.com/FionaWilsonVPD/status/1424779599188221953?ref_src=twsrc%5Etfw">
              August 9, 2021
            </a>
          </blockquote> 
          <ScriptEmbed 
            src='https://platform.twitter.com/widgets.js'
            charSet='utf-8'
          />
        <p> 
        Covid-19 is striking hardest at the poorest members of our societies and unfortunately Indigenous peoples are also over represented in the poorest sections of society.
        </p>
        <p>  
        To raise awareness in our own backyard in Australia - we have put together this Infographic on Australia's own Indigenous population. It is striking to see just how far behind the rest of the population Indigenous Australians still are. 
        </p>
        <p>
        Much more work is needed under the "Close the Gap" campaign (<a href="https://humanrights.gov.au/our-work/aboriginal-and-torres-strait-islander-social-justice/projects/close-gap-indigenous-health#:~:text=The%20Close%20the%20Gap%20Campaign,Indigenous%20Australians%20within%20a%20generation." target="_blank">see here</a>) in what is surely the closest issue to Australia's heart.

        </p>
        </GridItem>

        <GridItem xs={12} sm={8} md={8}>

        <h3>Australias Indigenous Population Statistics</h3>
        <p>
        Check out the infographic on Australia's Indigenous Population below:
        </p>

        </GridItem>

        <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-08-08-IndigenousPeople/international-day-of-the-worlds-indigenous-peoples-australia-2020-infographic.jpg"
                      alt="International Day of The Worlds Indigenous Peoples Australia 2020"
                      className={imgClasses}
                    />
                    <p>Source: ABS 2019 - <a href="http://www.aihw.gov.au" target="_blank">http://www.aihw.gov.au</a></p>
            </GridItem>
        <GridItem xs={12} sm={12} md={12}> 

        Source: ABS 2019 - <a href="http://www.aihw.gov.au" target="_blank">http://www.aihw.gov.au</a>
        

        <h3>Extra: Interested in buying a Facemask Supporting Uganda? - Available August 12th 2020!</h3>

        </GridItem>

        <GridItem xs={12} sm={12} md={12}> 
                    <img
                      src="/img/posts/2020-08-08-IndigenousPeople/yimbauganda.png"
                      alt="yimba uganda covid masks"
                      className={imgClasses}
                    />
                    <p><br></br><i>Ubud is amazing btw...</i> 😎🌋🗿</p>
            </GridItem>
        <GridItem xs={12} sm={12} md={12}> 

        <p>
        Indigenous Peoples Day is also a time to remind us of other cultures around the world who could do with our support.
        </p>
        <p>
        Our friends at <a href="https://www.matthewproctor.com/australian_postcodes" target="_blank">Australian Postcode Database</a> run a charity called "Winds of Hope", supporting Ugandan youth. This charity aims to "Equip Ugandan youth with sustainable income generating skills!" - especially through fashion design and clothing manufacture.
        </p>
        <p>
        This is a great way for Victorians and other Australians to get mask and contribute to charity efforts at the same time. If you'd like to buy a mask go here, so many options!!! 😀 <a href="https://shop.windsofhope.org.au/collections/frontpage" target="_blank" style={{wordWrap: 'break-word'}}>https://shop.windsofhope.org.au/collections/frontpage</a>
        <br /><br />
        Also check out <a href="https://libguides.hale.wa.edu.au/general/reconciliationweek" target="_blank">Hale School Library Guides</a> - where are infographic above was featured :-)

        </p>

        </GridItem>




        
 
      </GridContainer>
    </div>

  );
}
